export default {
    upload_photos: {
        heading: 'Галерея изображений',
        content: 'Изображения - отличный способ показать ваш продукт и ваше мастерство.',
    },
    schedule: {
        heading: 'Расписание',
        content_create: 'Создайте свои расписания для услуги',
        content: 'Ваши расписания',
    },
    buttons: {
        create_new: 'Создать новое',
        use_existing: 'Использовать существующее',
        go_to_offers: 'Перейти к услугам',
    },
    categories: 'Категории',
    choose_existing: 'Выберите существующие доступности',
    create_new: 'Создать новую доступность',
    add_availability_to_offer:
        'Если вы выберете определенное расписание, все услуги на этом расписании будут использовать тот же временной интервал. Это означает, что если вы забронируете определенный временной интервал на расписании, этот временной интервал будет недоступен для всех услуг, которые его используют.',
    remove_availability: 'Вы уверены, что хотите удалить это расписание из этой услуги?',
}
